import { call, delay, put, select, take, takeLatest } from "redux-saga/effects";
// import { triggerConfirmar, yes } from "./confirmationSlice";
import { setTimerAttr, triggerLoadTimer, triggerPauseLap, triggerResetLap, triggerResetSession, triggerResumeLap, triggerStartLap, triggerStopLap, triggerTimerCounterTick } from "./TimerSlice";

import { server_url } from '../core/config_geral'
import axios from 'axios';

// function* doConfirmar() {
//     var cb = yield select ((state) => state.confirmation.cb)
//     yield put(yes())

//     if(isNotNull(cb)) {
//         cb()
//     }
// }

// export function* listenConfirmar() {
//     yield takeLatest(triggerConfirmar, doConfirmar)
// }

// INICIO HELPER FUNCTIONS

// Função auxiliar para adicionar zero à esquerda se o valor for menor que 10
function adicionarZero(valor) {
    return valor < 10 ? `0${valor}` : valor;
}

function calculaDiffAgora(dataRecebida) {
    // Converter a data recebida para um objeto Date
    const dataRecebidaObjeto = new Date(dataRecebida);

    // Obter a data atual
    const dataAtual = new Date();

    // Calcular a diferença em milissegundos
    const diferencaEmMilissegundos = Math.abs(dataAtual - dataRecebidaObjeto);

    // Calcular horas, minutos e segundos
    const horas = Math.floor(diferencaEmMilissegundos / 3600000); // 1 hora = 3600000 milissegundos
    const minutos = Math.floor((diferencaEmMilissegundos % 3600000) / 60000); // 1 minuto = 60000 milissegundos
    const segundos = Math.floor((diferencaEmMilissegundos % 60000) / 1000); // 1 segundo = 1000 milissegundos

    // Formatar o resultado
    const diferencaFormatada = `${adicionarZero(horas)}:${adicionarZero(minutos)}:${adicionarZero(segundos)}`;

    return diferencaFormatada;
}


function calcularDiferencaEntreDatas(data1, data2) {
    const diferencaEmMilissegundos = Math.abs(new Date(data1) - new Date(data2));
    return diferencaEmMilissegundos;
}

// Função para subtrair a diferença de uma data fornecida
function subtrairDiferencaDaData(dataBase, diferencaEmMilissegundos) {
    const novaData = new Date(new Date(dataBase).getTime() - diferencaEmMilissegundos);
    return novaData.toISOString();
}

// FIM HELPER FUNCTIONS

function* salvaAlteracao() {
    yield put(setTimerAttr({
        campo: "saving",
        value: true
    }))


    var token = yield select((state) => state.auth.token)

    console.log(token)

    var payload = {
        "action" : "REL_UPLOAD_RELATORIO",
        "runNow" : true,
        "payload" : JSON.stringify({
            "codigo" : "REL_ANANO_MANAGER_TIMER",
            "tenantId" : "c241f070-887a-45cc-98ad-6e79b0b59061",
        })
    }

    var formData = new FormData()

    var session = yield select((state) => state.timer.session)
    var lap = yield select((state) => state.timer.lap)
    var relatorio = {
        session,
        lap
    }

    formData.append("file",
        new Blob([JSON.stringify(relatorio)], {
            type: "application/json"
        }))
    formData.append("data",
        new Blob([JSON.stringify(payload)], {
            type: "application/json"
        }))

    var r = yield call(() => axios.post(server_url + "/rpc", formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
    }).then(response => response)
        .catch(error => error))
        
    console.log(r)


    yield delay(1000)
    yield put(setTimerAttr({
        campo: "saving",
        value: false
    }))
}

function* doLoadTimer() {
    yield put(setTimerAttr({
        campo: "loading",
        value: true
    }))


    var token = yield select((state) => state.auth.token)

    var payload = {
        "action" : "REL_DOWNLOAD_RELATORIO",
        "runNow" : true,
        "payload" : JSON.stringify({
            "codigo" : "REL_ANANO_MANAGER_TIMER",
            "tenantId" : "c241f070-887a-45cc-98ad-6e79b0b59061",
            "versao" : "latest"
        })
    }

    var formData = new FormData()
    // formData.append("file",
    //     new Blob([JSON.stringify("")], {
    //         type: "application/json"
    //     }))
    formData.append("data",
        new Blob([JSON.stringify(payload)], {
            type: "application/json"
        }))

    var r = yield call(() => axios.post(server_url + "/rpc", formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
    }).then(response => response)
    .catch(error => error))
    
    var session = null
    var lap = null


    if(r.status === 200) {
        session = r.data.session
        lap = r.data.lap
    }
    
    yield put(setTimerAttr({
        campo : "session",
        value : session,
    }))
    yield put(setTimerAttr({
        campo : "lap",
        value : lap,
    }))

    yield delay(100)
    yield put(setTimerAttr({
        campo: "loading",
        value: false
    }))

    yield put(triggerTimerCounterTick())

}

function* doTimerCounterTick() {

    yield setTimerAttr({
        campo: "now",
        value: new Date().toISOString(),
    })

    var session = yield select((state) => state.timer.session)

    if (session != null) {
        var label = calculaDiffAgora(session.start)
        yield put(setTimerAttr({
            campo: "session",
            value: {
                start: session.start,
                label: label
            }
        }))
    }

    var lap = yield select((state) => state.timer.lap)

    if (lap != null) {

        if (lap.paused === false) {
            var label = calculaDiffAgora(lap.start)
            yield put(setTimerAttr({
                campo: "lap",
                value: {
                    start: lap.start,
                    label: label,
                    paused: false,
                }
            }))
        } else {
            // Nada?
        }
    }

    yield delay(2500)
    yield put(triggerTimerCounterTick())
}

function* doResetSession() {
    console.log("reset session")

    var data = new Date().toISOString()

    yield put(setTimerAttr({
        campo: "session",
        value: {
            start: data,
            label: calculaDiffAgora(data)
        },
    }))

    
    yield call(() => salvaAlteracao())
}

function* doStartLap() {
    var data = new Date().toISOString()

    yield put(setTimerAttr({
        campo: "lap",
        value: {
            start: data,
            label: calculaDiffAgora(data),
            paused: false,
        },
    }))


    yield call(() => salvaAlteracao())
}

function* doPauseLap() {


    var lap = yield select((state) => state.timer.lap)

    if (lap != null) {
        if (lap.paused === false) {

            yield put(setTimerAttr({
                campo: "lap",
                value: {
                    start: lap.start,
                    label: lap.label,
                    paused: new Date().toISOString(),
                },
            }))

            
    yield call(() => salvaAlteracao())
        }
    }
}

function* doResumeLap() {
    const lap = yield select((state) => state.timer.lap)

    if (lap != null && lap.paused !== false) {

        console.log(lap.start, lap.paused)
        var newDate = subtrairDiferencaDaData(new Date().toISOString(), calcularDiferencaEntreDatas(
            lap.start,
            lap.paused
        ))
        yield put(setTimerAttr({
            campo: "lap",
            value: {
                start: newDate,
                label: calculaDiffAgora(newDate),
                paused: false,
            },
        }))
    }


    
    yield call(() => salvaAlteracao())
}

function* doStopLap() {
    yield put(setTimerAttr({
        campo: "lap",
        value: null,
    }))

    
    yield call(() => salvaAlteracao())
}

function* doResetLap() {

    yield put(setTimerAttr({
        campo: "lap",
        value: null,
    }))
    yield doStartLap()

}

export function* listenTriggerLoadTimer() {
    yield takeLatest(triggerLoadTimer, doLoadTimer)
}

export function* listenTriggerTimerCounterTick() {
    yield takeLatest(triggerTimerCounterTick, doTimerCounterTick)
}

export function* listenTriggerResetSession() {
    yield takeLatest(triggerResetSession, doResetSession)
}

export function* listenTriggerStartLap() {
    yield takeLatest(triggerStartLap, doStartLap)
}

export function* listenTriggerPauseLap() {
    yield takeLatest(triggerPauseLap, doPauseLap)
}

export function* listenTriggerResumeLap() {
    yield takeLatest(triggerResumeLap, doResumeLap)
}

export function* listenTriggerStopLap() {
    yield takeLatest(triggerStopLap, doStopLap)
}

export function* listenTriggerResetLap() {
    yield takeLatest(triggerResetLap, doResetLap)
}